module.exports = __webpack_public_path__ + "static/media/ethereumFoundation.2871bb1c.webp";